import React from 'react';
import { InputFieldState, ApplicantState, AgencyState, AppointmentGroupState } from '../types';
import ResetButton from '../ResetButton';
import SaveButton from '../SaveButton';
import DocumentTypeForm from "../DocumentTypeForm";
import SubmissionDateForm from '../SubmissionDateForm';
import DelegationDateForm from '../DelegationDateForm';
import ApplicantForm from '../ApplicantForm';
import AgenciesForm from '../AgenciesForm';
import OtherAppointmentsForm from '../OtherAppointmentsForm';
import AdditionalItemsForm from '../AdditionalItemsForm';
import AppointmentGroupsForm from '../AppointmentGroupsForm';
import CreatePdfButton from '../CreatePdfButton';

/**
 * EnteringDocumentInformationFormコンポーネント用のPropsです。
 * @interface EnteringDocumentInformationFormProps
 */
interface EnteringDocumentInformationFormProps {

  documentName: InputFieldState;
  setDocumentName: (documentName: InputFieldState) => void;

  submissionDate: InputFieldState;
  setSubmissionDate: (submissionDate: InputFieldState) => void;

  delegationDate: InputFieldState;
  setDelegationDate: (delegationDate: InputFieldState) => void;

  applicant: ApplicantState;
  setApplicant: (applicant: ApplicantState) => void;

  agencies: AgencyState[];
  setAgencies: (agencies: AgencyState[]) => void;

  appointmentGroups: AppointmentGroupState[];
  setAppointmentGroups: (appointmentGroups: AppointmentGroupState[]) => void;

  otherAppointments: string[];
  setOtherAppointments: (otherAppointments: string[]) => void;

  additinalItems: string[];
  setAdditionalItems: (additinalItems: string[]) => void;

  saveForm: () => void;

  /**
   * フォームをリセットする関数です。
   * @memberof EnteringDocumentInformationFormProps
   */
  resetForm: () => void;

  isSubmitDiabled: boolean;

  createPdfMain: () => void;

  createPdfSub: () => void;

}

/**
 * 書類情報入力フォームコンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const EnteringDocumentInformationForm: React.FC<EnteringDocumentInformationFormProps> = ({
  documentName,
  setDocumentName,
  submissionDate,
  setSubmissionDate,
  delegationDate,
  setDelegationDate,
  applicant,
  setApplicant,
  agencies,
  setAgencies,
  appointmentGroups,
  setAppointmentGroups,
  otherAppointments,
  setOtherAppointments,
  additinalItems,
  setAdditionalItems,
  saveForm,
  resetForm,
  isSubmitDiabled,
  createPdfMain,
  createPdfSub
}) => {
  return (
    <>
      <div className="mb-3 rounded-3 align-baseline" style={{backgroundColor: '#ffe4b5'}}>
        <h3 className="h5 py-2 px-2 text-primary fw-bold">書類情報を入力する</h3>
      </div>
      <div className="px-3">
        <div className="my-4">
          <DocumentTypeForm
            documentName={documentName}
            onChange={setDocumentName}
          />
        </div>
        <div className="my-4">
          <SubmissionDateForm
            date={submissionDate}
            onChange={setSubmissionDate}
          />
        </div>
        <div className="my-4">
          <DelegationDateForm
            delegationDate={delegationDate}
            submissionDate={submissionDate}
            onChange={setDelegationDate}
          />
        </div>
        <div className="my-4">
          <ApplicantForm applicant={applicant} onChange={setApplicant} />
        </div>
        <div className="my-4">
          <AgenciesForm
            agencies={agencies}
            onChange={setAgencies}
          />
        </div>
        <AppointmentGroupsForm
          appointmentGroups={appointmentGroups}
          onChange={setAppointmentGroups}
        />
        <div className="mt-3 small">（※）工業所有権に関する手続等の特例に関する法律施行規則　様式第６ 包括委任状提出書 様式備考８の文例に記載のない委任事項</div>
        <div className="my-4">
          <OtherAppointmentsForm
            otherAppointments={otherAppointments}
            onChange={setOtherAppointments}
          />
        </div>
        <div className="my-4">
          <AdditionalItemsForm
            additionalItems={additinalItems}
            onChange={setAdditionalItems}
          />
        </div>
        <div className="text-end">
          <span className="ms-3">
            <SaveButton onClick={saveForm} />
          </span>
          <span className="ms-3">
            <ResetButton onClick={resetForm} />
          </span>
        </div>
        <div className="row mt-5">
          <div className="col-lg-6 col-12 pe-lg-3 my-1 text-lg-end text-center d-grid">
            <CreatePdfButton
              buttonLabel='包括委任状提出書を作成'
              isDisabled={isSubmitDiabled}
              onClick={createPdfMain}
            />
          </div>
          <div className="col-lg-6 col-12 pe-lg-3 my-1 text-lg-start text-center d-grid">
            <CreatePdfButton
              buttonLabel='包括委任状を作成'
              isDisabled={isSubmitDiabled}
              onClick={createPdfSub}
            />
          </div>
          {
            isSubmitDiabled ? <div className="text-end col-12"><span className="small text-danger">※ 必須事項が入力されていないか、入力内容に誤りがあります。</span></div> : ''
          }
        </div>
      </div>
    </>
  );
}

export default EnteringDocumentInformationForm;